import { Box } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Component } from "@outschool/ownership-areas";
import {
  ContinueWithFacebook,
  LoginUserFeedback,
  useAuthError,
} from "@outschool/ui-auth";
import _ from "lodash";
import React from "react";

import { FACEBOOK_APP_ID } from "../../../../../shared/Env";
import type { CreateOrLoginError } from "../../../generated/graphql";
import { useLearnerLoginWithRedirect } from "../../../hooks/authentication";
import { useLearnerAuth } from "../../../providers/LearnerAuthProvider";

export default function ConnectFacebook() {
  const { learnerAuth } = useLearnerAuth();
  const hasFacebook = React.useMemo(
    () => (learnerAuth ? _.keyBy(learnerAuth.providers)["Facebook"] : false),
    [learnerAuth],
  );
  const [userError, setUserError] = React.useState<React.ReactNode>(null);
  const generateLoginError = useAuthError("Facebook");
  const url = React.useMemo(() => {
    if (typeof window !== "undefined") {
      return window.location.href;
    }
    return "";
  }, []);
  const handleAuthError = React.useCallback(
    (
      error: unknown,
      message: React.ReactNode = "Sorry that didn't work, try again",
    ) => {
      OsPlatform.captureError(error, {
        tags: { component: Component.LearnerMode },
      });
      setUserError(message);
    },
    [],
  );

  const handleLoginError = React.useCallback(
    (error: CreateOrLoginError) => {
      const errorObject = new Error(error);
      handleAuthError(errorObject, generateLoginError(error));
    },
    [handleAuthError, generateLoginError],
  );

  useLearnerLoginWithRedirect(handleLoginError, url);

  return (
    <Box sx={{ marginBottom: "0.5em" }}>
      {hasFacebook ? (
        <Box>Your Facebook account is linked and you may use it to log in.</Box>
      ) : (
        <Box>
          {userError && (
            <Box
              sx={{
                marginBottom: "0.5em",
              }}
            >
              <LoginUserFeedback
                userFeedbackMessage={userError}
                isError={true}
              />
            </Box>
          )}
          <ContinueWithFacebook
            setAuthStrategy={() => {}}
            trackingName="learner_login.learner_settings.connect_with_facebook"
            clientId={FACEBOOK_APP_ID!}
          />
        </Box>
      )}
    </Box>
  );
}
